import { render } from "./NewTab.vue?vue&type=template&id=70310722&scoped=true"
import script from "./NewTab.vue?vue&type=script&lang=js"
export * from "./NewTab.vue?vue&type=script&lang=js"

import "./NewTab.vue?vue&type=style&index=0&id=70310722&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70310722"]])

export default __exports__